
import { Textarea } from "@/components/ui/textarea";
import { FilePenLine, FileText, Microscope } from "lucide-react";
import { LabTestSelector } from "./LabTestSelector";

interface ClinicalDetailsProps {
  clinicalFindings: string;
  diagnosis: string;
  labTests: string;
  onClinicalFindingsChange: (value: string) => void;
  onDiagnosisChange: (value: string) => void;
  onLabTestsChange: (value: string) => void;
}

export function ClinicalDetails({
  clinicalFindings,
  diagnosis,
  labTests,
  onClinicalFindingsChange,
  onDiagnosisChange,
  onLabTestsChange
}: ClinicalDetailsProps) {
  return (
    <div className="space-y-6">
      {/* Clinical Findings Section */}
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <FilePenLine className="h-5 w-5 text-hospital-primary" />
          <h3 className="font-medium">Clinical Findings / Observations</h3>
        </div>
        <div className="space-y-2">
          <Textarea 
            id="clinicalFindings"
            value={clinicalFindings}
            onChange={(e) => onClinicalFindingsChange(e.target.value)}
            placeholder="Enter clinical findings and observations"
            className="resize-none h-20"
          />
        </div>
      </div>
      
      {/* Diagnosis Section */}
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <FileText className="h-5 w-5 text-hospital-primary" />
          <h3 className="font-medium">Diagnosis</h3>
        </div>
        <div className="space-y-2">
          <Textarea 
            id="diagnosis"
            value={diagnosis}
            onChange={(e) => onDiagnosisChange(e.target.value)}
            placeholder="Enter diagnosis"
            className="resize-none h-20"
          />
        </div>
      </div>
      
      {/* Lab Tests Section */}
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <Microscope className="h-5 w-5 text-hospital-primary" />
          <h3 className="font-medium">Laboratory Tests</h3>
        </div>
        <div className="space-y-2">
          <LabTestSelector 
            value={labTests}
            onChange={onLabTestsChange}
          />
        </div>
      </div>
    </div>
  );
}
